"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("../../constants/index.js");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var INCA = _index.urlParams.INCA;

var incaImpressions = function incaImpressions(event) {
  var anchorElements = document.getElementsByTagName('a');
  var anchors = Array.from(anchorElements);
  var incaValues = anchors.map(function (_ref) {
    var href = _ref.href;
    return href;
  }).filter(function (href) {
    return href.toLowerCase().includes("".concat(INCA.toLowerCase(), "="));
  }).map(function (href) {
    var url = new URL(href);
    if (!url.origin.includes('telus')) return null;
    var lowerCaseValue = url.searchParams.get(INCA.toLowerCase());
    var upperCaseValue = url.searchParams.get(INCA.toUpperCase());
    return lowerCaseValue || upperCaseValue;
  }).filter(Boolean);
  if (!incaValues.length) return event;
  var uniqueIncaValues = new Set(_toConsumableArray(incaValues));

  var productListItems = _toConsumableArray(event.xdm.productListItems || []);

  uniqueIncaValues.forEach(function (value) {
    return productListItems.push({
      name: 'int_cmp_imp',
      _telus: {
        internalCampaignName: value,
        campaignImpression: 1
      }
    });
  });
  event.xdm.productListItems = productListItems;
  return event;
};

var _default = incaImpressions;
exports["default"] = _default;